import { User, Clock } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

interface LastUpdatedValue {
  updatedBy: string;
  updatedAt: string | number;
  avatar?: string;
}

interface LastUpdatedCellProps {
  value: LastUpdatedValue | null;
  readOnly?: boolean;
}

export function LastUpdatedCell({ value }: LastUpdatedCellProps) {
  // Last Updated é sempre read-only
  
  if (!value) {
    return <span className="text-gray-400 text-sm">-</span>;
  }

  const { updatedBy, updatedAt, avatar } = value;
  
  let timeAgo = '';
  try {
    const date = typeof updatedAt === 'number' ? new Date(updatedAt) : new Date(updatedAt);
    if (!isNaN(date.getTime())) {
      timeAgo = formatDistanceToNow(date, { addSuffix: true, locale: ptBR });
    } else {
      timeAgo = 'data inválida';
    }
  } catch (e) {
    timeAgo = 'data inválida';
  }

  return (
    <div className="flex items-center gap-2">
      {avatar ? (
        <img src={avatar} alt={updatedBy} className="w-6 h-6 rounded-full" />
      ) : (
        <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center">
          <User className="w-4 h-4 text-green-600" />
        </div>
      )}
      <div className="flex flex-col">
        <span className="text-sm font-medium text-gray-700">{updatedBy}</span>
        <div className="flex items-center gap-1 text-xs text-gray-500">
          <Clock className="w-3 h-3" />
          <span>{timeAgo}</span>
        </div>
      </div>
    </div>
  );
}
